import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { developmentDiagnosticsEnabled } from '../../../lib/diagnostics';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
const TONE = {
    warning: 'border-warning/60 bg-warning-muted text-warning',
    neutral: 'border-[color:var(--border-dashed)] bg-muted text-muted-foreground'
};
/** A claim shown as unverified (hearsay) or an advisory note, in a dashed frame. */ export function SpecraUnverifiedClaim({ actions, attribution, claim, className, compact = false, confidence, kind = 'claim', kindLabel = 'Hearsay', onActivate, tone = 'warning', verified = false, ...props }) {
    const showActions = Boolean(actions) && !compact;
    const conflict = showActions && Boolean(onActivate);
    React.useEffect(()=>{
        if (conflict && developmentDiagnosticsEnabled) {
            console.warn('SpecraUnverifiedClaim: actions and onActivate are exclusive; onActivate ignored');
        }
    }, [
        conflict
    ]);
    const activate = showActions ? undefined : onActivate;
    const body = kind === 'note' ? claim : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: verified ? 'Claim: ' : 'Unverified claim: '
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "font-medium",
                children: kindLabel
            }),
            ' · ',
            claim,
            compact ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    attribution ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            " — ",
                            attribution
                        ]
                    }) : null,
                    confidence ? ` · ${confidence}` : null,
                    verified ? null : ' · unverified'
                ]
            })
        ]
    });
    const classes = cn('rounded-[var(--radius-control)] border border-dashed text-left leading-[var(--lh-snug)]', TONE[tone], compact ? 'inline-flex max-w-full items-center px-[var(--space-1-5)] py-[var(--space-0-5)] text-[length:var(--fs-ui-meta)]' : 'block px-[var(--space-2-5)] py-[var(--space-2)] text-[length:var(--fs-ui-body)]', activate && cn(specraFocusRing, 'hover:border-warning'), className);
    const content = compact ? /*#__PURE__*/ _jsx("span", {
        className: "truncate",
        children: body
    }) : showActions ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "min-w-0",
                children: body
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-[var(--space-1-5)] flex flex-wrap items-center gap-[var(--space-1-5)]",
                "data-claim-actions": "",
                children: actions
            })
        ]
    }) : body;
    if (activate) {
        const { onClick, ...rest } = props;
        return /*#__PURE__*/ _jsx("button", {
            ...rest,
            className: classes,
            onClick: (event)=>{
                onClick?.(event);
                activate();
            },
            type: "button",
            children: content
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: classes,
        role: "note",
        ...props,
        children: content
    });
}
